import React from 'react';
import InfoPageLayout from './InfoPageLayout';

export default function ContactPage() {
  return (
    <InfoPageLayout
      title="Contact | Lilycove"
      description="Get in touch with the Lilycove team."
      heading="Contact"
      body="Questions, feedback, or partnership requests can be sent to the Lilycove team at support@lilycove.io. We review requests regularly and prioritize collector-impacting issues first."
    />
  );
}
